import { Icon, Reveal } from '@nexa/ui';

interface AgentType {
  readonly icon: 'globe' | 'user-round-cog' | 'users-round';
  readonly title: string;
  readonly body: string;
}

export interface AgentTypeCardsProps {
  readonly types: readonly AgentType[];
}

/**
 * Ba card loại agent — `template.html:904-916`.
 *
 * `Reveal` bọc TỪNG card, đúng như thiết kế (`data-reveal` nằm trên từng card ở :905 :909 :913).
 * Chỗ đặt `data-reveal` không chỉ đổi hiệu ứng: cổng `design:diff` đúng được là nhờ hai phía dịch
 * cùng một lượng, và tính chất đó vỡ nếu ta bọc khác thiết kế. Cổng giờ đếm số khối reveal hai
 * bên cho từng section nên lệch là nó báo.
 *
 * `h-full` trên CẢ `Reveal` lẫn card: trong lưới, `Reveal` giãn hết chiều cao ô còn card chỉ cao
 * theo nội dung ⇒ card hở đáy ô. jsdom không chạy layout engine nên không test nào bắt được.
 *
 * KHÔNG gộp với `CapabilityCards`: hai khối lệch nhau ở 7 trong 9 thuộc tính (nền, viền, padding,
 * màu icon, cỡ tiêu đề, tone thân, hover).
 */
export function AgentTypeCards({ types }: AgentTypeCardsProps) {
  return (
    <div className="mt-11 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {types.map((type) => (
        <Reveal key={type.title} className="h-full">
          <div className="h-full rounded-card border border-[var(--on-dark-line-16)] bg-[var(--on-dark-fill-07)] p-[26px] transition [transition-duration:var(--duration-hover)] hover:bg-[var(--on-dark-fill-12)]">
            <div className="flex items-center gap-2.5">
              <Icon name={type.icon} size={19} className="text-white" />
              <span className="text-lead font-bold text-white">{type.title}</span>
            </div>
            <p className="mt-3 text-body text-[var(--on-dark-text-72)]">{type.body}</p>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
